import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { LoginActions } from "@Pages";
import Alert from "@mui/material/Alert";
import "./style.scss";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type FormData = {
    username: string;
    password: string;
    confirmpassword: string;
    resetPass: boolean;
};
interface FuncProps {
    onSendAction(arg: boolean): void;
}
export const ForgotPasswordForm: React.FC<FuncProps> = ({ onSendAction }) => {
    const { t } = useTranslation();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm<FormData>();
    const dispatch = useDispatch<any>();
    const [sendAction, setSendAction] = useState(false);

    const onSubmit = async ({ username }: FormData) => {
        onSendAction(true);
        try {
            dispatch(
                LoginActions.PostForgotAccount({
                    username,
                })
            );
        } catch (error) {
            console.error(error);
        } finally {
            setSendAction(true);
            reset();
        }
    };

    return !sendAction ? (
        <form
            className="ForgotPasswordForm"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
        >
            {errors.username && (
                <div>
                    <Alert severity="error" variant="filled">
                        {t("pages.forgot_password.errors.empty")}
                    </Alert>
                </div>
            )}
            <input
                type="text"
                className="ForgotPasswordForm__input"
                placeholder={t("pages.forgot_password.username")}
                {...register("username", { required: true })}
            />

            <button type="submit" className="ButtonReset ButtonReset-blue ">
                {t("pages.forgot_password.send_btn")}
            </button>
        </form>
    ) : (
        sendAction && (
            <>
                <MailOutlineIcon
                    style={{ fontSize: "150px" }}
                    className="mail-icon-color"
                />
                <Link
                    style={{
                        color: "#ffffffff",
                        fontSize: "24px",
                        textTransform: "none",
                    }}
                    to="/"
                >
                    {t("pages.forgot_password.back")}
                </Link>
            </>
        )
    );
};

export default ForgotPasswordForm;
